export default "__VITE_ASSET__kozeXvRy__"